import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import type { CoreActionCreator } from '../core/resourceStoreTypes';
import * as actions from './taxesActions';
import { getLastSyncDate } from './taxesSelectors';
import { transformClientResourceToRequestData, transformServerResourceToClientResource } from './taxesTransformers';
import * as taxesTypes from './taxesTypes';

const mkQcsSyncTagsConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<taxesTypes.TaxProps>();

const mkResourceConfig = (successAction: CoreActionCreator<any, any>, failureAction: CoreActionCreator<any, any>) =>
  mkQcsSyncTagsConfig({
    resourceName: 'taxes',
    resourceBaseUrl: '/taxes/tax-calculations',
    getLastSyncDate,
    applyResourceFromCRUDResponse: true,

    transformClientResourceToRequestData,
    transformServerResourceToClientResource,

    successAction,
    failureAction,
  });

export function* getTaxCalculationsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getTaxCalculationsSuccess, actions.getTaxeCalculationFailure);
  yield resourceSagaUtils.takeAndDebounce(
    actions.getTaxCalculations,
    resourceSagaUtils.qcsSyncGetResources<taxesTypes.TaxProps>,
    resourceConfig,
  );
}

export function* createTaxActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createTaxSuccess, actions.createTaxFailure);
  yield takeEvery(actions.createTax.type, resourceSagaUtils.qcsSyncCreateResource<taxesTypes.TaxProps>, resourceConfig);
}

export function* updateTaxActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateTaxSuccess, actions.updateTaxFailure);
  yield takeEvery(actions.updateTax.type, resourceSagaUtils.qcsSyncUpdateResource<taxesTypes.TaxProps>, resourceConfig);
}

export function* taxesFailureActionWatcher() {
  yield takeEvery([actions.createTaxFailure.type, actions.updateTaxFailure.type], actions.getTaxCalculations);
}

export function* performTaxCalcActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.performTaxCalcSuccess, actions.performTaxCalcFailure);
  yield takeEvery(
    actions.performTaxCalc.type,
    resourceSagaUtils.qcsSyncUpdateResource<taxesTypes.TaxProps>,
    resourceConfig,
  );
}

export default [
  getTaxCalculationsActionWatcher,
  createTaxActionWatcher,
  updateTaxActionWatcher,
  taxesFailureActionWatcher,
  performTaxCalcActionWatcher,
];
